<template>
  <div class="TestResults" @click="toggleConnectionTest()">
      <div class="tr-container" @click="$event.stopPropagation()">
        <h1 class="tr-title">{{ $t('Verbindungstest') }}</h1>
        <div>
          <!-- CONNECTION -->
          <div class="tr-waiting" v-show="connectionTest == null">{{ $t('Ihre Verbindung wird überprüft') }}...</div>
          <!-- Wenn Connection Test erfolgreich-->
          <div v-if="connectionTest == 'success'" class="tr-success">{{ $t('Der Verbindungsaufbau war erfolgreich') }}</div>
          <!-- Wenn Connection Test NICHT erfolgreich-->
          <div v-if="connectionTest == 'failed'">
            <div class="tr-failed">{{ $t('Der Verbindungsaufbau war nicht erfolgreich') }}</div>
            <div>{{ $t('Folgende Fehler sind aufgetreten:') }}</div>
            <tbody v-for="failedTest in this.connectionResult.failedTests" :key="failedTest.error.message">
                <td>{{failedTest.error.message}}</td>
            </tbody>
          </div>

          <!-- QUALITY -->
          <div class="tr-waiting" v-show="qualityTest == null">{{ $t('Ihre Verbindungsqualität wird überprüft') }}...</div>
          <!-- Wenn Qualitäts Test erfolgreich-->
          <div v-if="qualityTest == 'success'">
            <div class="tr-success">{{ $t('Die Überprüfung ihrer Verbindungsqualität war erfolgreich') }}</div>
            <div>{{ $t('Ergebniss des Tests:') }}</div>
            <table>
              <div class="tr-table">
                <tbody v-if="this.qualityResult.video.supported === true">
                  <tr>
                    <th colspan="2">Video</th>
                  </tr>
                  <tr>
                    <td>{{ $t('Qualität') }}:</td>
                    <td>{{ this.qualityResult.video.mos.toFixed(1) }} / 4.5</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Durchschnittliche Bitrate') }}:</td>
                    <td>{{ this.qualityResult.video.bitrate.toFixed(0) }} kbps</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Durchschnittliche Framerate') }}:</td>
                    <td>{{ this.qualityResult.video.frameRate.toFixed(0) }} fps</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Verlustrate der Pakete') }}:</td>
                    <td>{{ this.qualityResult.video.packetLossRatio.toFixed(2) }}%</td>
                  </tr>
                </tbody>
              </div>
              <div class="tr-table">
                <tbody v-if="this.qualityResult.video.supported === false">
                  <tr>
                    <th colspan="2">Video</th>
                  </tr>
                  <tr>
                    <td>{{ $t('Fehler bei der Video Übertragung:') }}</td>
                    <td>{{this.qualityResult.video.reason }}</td>
                  </tr>
                </tbody>
              </div>
              <div class="tr-table">
                <tbody v-if="this.qualityResult.audio.supported === true">
                  <tr>
                    <th colspan="2">Audio</th>
                  </tr>
                  <tr>
                    <td>{{ $t('Qualität') }}:</td>
                    <td>{{ this.qualityResult.audio.mos.toFixed(1) }} / 4.5</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Durchschnittliche Bitrate') }}:</td>
                    <td>{{ this.qualityResult.audio.bitrate.toFixed(0) }} kbps</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Verlustrate der Pakete') }}:</td>
                    <td>{{ this.qualityResult.audio.packetLossRatio.toFixed(2) }}%</td>
                  </tr>
                </tbody>
              </div>
              <div class="tr-table">
                <tbody v-if="this.qualityResult.audio.supported === false">
                  <tr>
                    <th colspan="2">Audio</th>
                  </tr>
                  <tr>
                    <td>{{ $t('Fehler bei der Audio Übertragung:') }}</td>
                    <td>{{this.qualityResult.audio.reason }}</td>
                  </tr>
                </tbody>
              </div>
            </table>
          </div>
          <!-- Wenn Qualitäts Test NICHT erfolgreich -->
          <div v-if="qualityTest == 'failed'">
            <div class="tr-failed">{{ $t('Der Qualitäts Test konnte nicht durchgeführt werden!') }}</div>
            <div>F{{ $t('Folgender Fehler ist aufgetreten:') }}</div>
            <tbody>
                <td>{{this.qualityError}}</td>
            </tbody>
          </div>

          <!-- BUTTONS -->
          <div class="tr-buttons">
            <md-button @click="repeatTest()" v-if="qualityTest != null && connectionTest != null"  class="normal-md-button" style="background-color: rgb(50, 50, 50);">
              {{ $t('Test Wiederholen') }}
            </md-button>
            <md-button @click="toggleConnectionTest();" v-if="qualityTest == null || connectionTest == null"  class="normal-md-button" style="background-color: rgb(50, 50, 50);">
              {{ $t('Abbrechen') }}
            </md-button>
            <md-button @click="toggleConnectionTest();" v-if="qualityTest != null && connectionTest != null"  class="accent-md-button" style="margin-left: 5px; background-color: var(--primaryColor);">
              {{ $t('Fertig') }}
            </md-button>
          </div>          
        </div>
      </div>
  </div>
</template>

<style scoped>
.TestResults{
  width: 100%;
  height: 100%; 
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background: #000000e3;
}
.tr-container{
  z-index: 10;
  padding: 30px;
  color: rgb(37, 37, 37);
  background: white;
  border-radius: 10px;
  width: 600px;
}
.tr-title{
  text-align: center;
  margin-bottom: 50px;
  margin-top: 10px;
}
.tr-table{
  margin-top: 20px;
  margin-bottom: 20px;
}
.tr-wrapper td{
  width: 200px;    
}
.tr-buttons{
  text-align: right;
  margin-top: 25px;
}
.tr-wrapper .md-button{
  color: white;
  border-radius: 5px;       
}
.tr-failed{
  color: red;
  margin-bottom: 10px;
}
.tr-success{
  color: green;
  margin-bottom: 10px;
}
.tr-waiting {
  animation: pulse 1s infinite ease-in-out;
  margin-bottom: 10px;
}
@keyframes pulse {
  0% {
    color: black;
  }
  50% {
    color: #afaeae;
  }
  100% {
    color: black;
  }
}
@media screen and (max-width: 900px) {
 .tr-container{
    width: 90%;
  }
}

</style>

<script>
import {mapGetters} from 'vuex';
import OT from "@opentok/client";
import * as RaumtaenzerApi from "@/api/raumtaenzer";

const NetworkTest = require('opentok-network-test-js').default;

export default {
  name: "TestResults",
  data: () => ({
    test: null,
    qualityTest: null,
    qualityResult: null,
    qualityError: null,
    connectionTest: null,
    connectionResult: null,
    connectionError: null,
  }),
  props: {
    toggleConnectionTest: Function,
    signIn: Function,
    audioDeviceId: String,
    videoDeviceId: String,
  },
  mounted() {
    this.testOpenTok();
  },
  computed: {
    ...mapGetters(['localUser']),
  },
  methods: {
    //Source: https://github.com/opentok/opentok-network-test-js
    async testOpenTok() {
      var self = this;
      const data = {
        user_id: this.localUser.id,
        user_name: this.localUser.getName(),
        role: this.selectedTab,
        room_id: this.localUser.id + "_test"
      };
      const accessToken = "test";
      const result = await RaumtaenzerApi.getVideoSessionInfoForRoom(accessToken, data);
      this.test = new NetworkTest(OT, {
            apiKey: result.api_key, // Add the API key for your OpenTok project here.
            sessionId: result.session_id, // Add a test session ID for that project
            token: result.access_token // Add a token for that session here
          },
          {
            timeout: 5000,
            audioSource: this.audioDeviceId,
            videoSource: this.videoDeviceId,
          }
      );
      self.test.testConnectivity().then((results) => {
        //Connection test success
        self.connectionResult = results;
        self.connectionTest = "success";

        self.test.testQuality(function updateCallback(stats) {}).then((results) => {
          //Quality test success
          self.qualityResult = results;
          self.qualityTest = "success";
          
        }).catch((error) => {
          //Quality test failed
          self.qualityError = error;
          self.qualityTest = "failed";
        });
      }).catch(function (error) {
        //Connection test failed
        self.connectionError = error;
        self.connectionTest = "failed";
        self.qualityTest = "failed";
      });
    },
    repeatTest(){
      this.qualityTest = null;
      this.qualityResult = null;
      this.qualityError = null;
      this.connectionTest = null;
      this.connectionResult = null;
      this.connectionError = null;
      this.testOpenTok();
    },
    cancleTest(){
      this.test.stop();
    },
  },
}
</script>